import {type FC} from 'react';
import type {MessageInfo} from '../types';
import {setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import {formatDate} from '../../../utils/DateUtil.ts';
import {Row} from '../types/MessagePage.styled.ts';

interface MessageRowProps {
    message: MessageInfo;
    index: number;
    totalCount: number;
    onRowClick: (message: MessageInfo) => void;
}

const MessageRow: FC<MessageRowProps> = ({message, index, totalCount, onRowClick}) => {
    const {ref, focused} = useFocusable({
        focusKey: `message-row-${message.id}`,
        onEnterPress: () => onRowClick(message),
        onArrowPress: (direction) => {
            if (direction === 'up') {
                if (index === 0) {
                    setFocus('message');
                    return false;
                }
            }
            return direction !== 'right';
        },
    });

    return (
        <Row ref={ref} $focused={focused} onClick={() => onRowClick(message)}>
            <td>{totalCount - index}</td>
            <td>{message.senior_name}</td>
            <td>{message.author}</td>
            <td>{formatDate(message.created_at)}</td>
            <td>{message.title}</td>
        </Row>
    );
};

export default MessageRow;
